/**
 * Widly used in legacy and leshacy parts of the app
 * so we need to keep it for now
 */

import type {ColorThemeFactory, ColorThemeFactoryOptions} from '.';

export const colorThemeV1Factory: ColorThemeFactory<ColorsV1> = (
  themeId,
  options,
) => {
  const shouldApplyAccentColor = !!options?.accentColor;

  switch (themeId) {
    case 'dark':
      return shouldApplyAccentColor
        ? applyAccentColor(darkV1, options)
        : darkV1;
    default:
      return shouldApplyAccentColor
        ? applyAccentColor(lightV1, options)
        : lightV1;
  }
};

const applyAccentColor = (
  colors: ColorsV1,
  options: ColorThemeFactoryOptions,
): ColorsV1 => {
  if (!options?.accentColor) {
    throw new Error('Accent color is required');
  }

  const accentColor = options.accentColor;
  const accentForSecondaryColors = options.accentForSecondaryColors || false;

  const result: ColorsV1 = {
    ...colors,
    secondary1: accentColor,
  };

  if (accentForSecondaryColors) {
    result.primary1 = accentColor;
  }

  return result;
};

export type ColorsV1 = typeof lightV1;

/**
 * @deprecated
 */
const lightV1 = {
  /**
   * @deprecated
   */
  background1: '#FFFFFF',

  /**
   * @deprecated
   */
  background2: '#F1F5F6',

  /**
   * @deprecated
   */
  background3: '#5E7685',

  /**
   * @deprecated
   */
  background4: '#D2DCE8',
  /**
   * @deprecated
   */
  background5: '#F1F5F6',
  /**
   * @deprecated
   */
  background6: '#F1F5F6',
  /**
   * @deprecated
   */
  background7: '#ADC1CD',

  /**
   * @deprecated
   */
  background8: '#294251',
  /**
   * @deprecated
   */
  background9: '#5E7685',
  /**
   * @deprecated
   */
  background10: '#1C3C61',
  /**
   * @deprecated
   */
  background11: '#819AA9',
  /**
   * @deprecated
   */
  background12: '#E5ECF0',
  /**
   * @deprecated
   */
  danger1: '#FA5353',
  /**
   * @deprecated
   */
  danger2: '#FA5353',

  /**
   * @deprecated
   */
  goal: {
    goal1: '#DFB998',
    goal2: '#F8C081',
    goal3: '#FFA06A',
    goal4: '#ED7D7D',
    goal5: '#72DDB7',
    goal6: '#9BB6B5',
    goal7: '#75B4B4',
    goal8: '#ADC3D4',
    goal9: '#87B9E8',
    goal10: '#57BAD3',
    goal11: '#659CB9',
  },
  /**
   * @deprecated
   */
  icon1: '#000000',
  /**
   * @deprecated
   */
  icon2: '#FFFFFF',
  /**
   * @deprecated
   */
  icon3: '#819AA9',
  /**
   * @deprecated
   */
  icon4: '#BACADE',
  /**
   * @deprecated
   */
  icon5: '#819AA9',
  /**
   * @deprecated
   */
  icon6: '#819AA9',
  /**
   * @deprecated
   */
  icon7: '#C2D0D9',
  /**
   * @deprecated
   */
  icon8: '#ADC1CD',
  /**
   * @deprecated
   */
  icon9: '#7BB5F6',
  /**
   * @deprecated
   */
  info1: '#559DEE',
  /**
   * @deprecated
   */
  note: {
    note1: '#FFFFFF',
    note2: '#C9F7EA',
    note3: '#DCEAFA',
    note4: '#FCECE4',
    note5: '#EEEAFB',
  },

  /**
   * @deprecated
   */
  onboarding1: '#EDC829',
  /**
   * @deprecated
   */
  primary1: '#559DEE',
  /**
   * @deprecated
   */
  primary2: '#4989D2',
  /**
   * @deprecated
   */
  primary3: '#CEE5FF',
  /**
   * @deprecated
   */
  primary4: '#295384',
  /**
   * @deprecated
   */
  secondary1: '#25D2A2',
  /**
   * @deprecated
   */
  secondary2: '#33DEAE',
  /**
   * @deprecated
   */
  secondary3: '#B5EFDF',

  /**
   * @deprecated
   */
  secondary4: '#D1EFE6',
  /**
   * @deprecated
   */
  secondary5: '#DFF4EE',
  /**
   * @deprecated
   */
  secondary6: '#D1EFE6',
  /**
   * @deprecated
   */
  secondary7: '#DFF4EE',
  /**
   * @deprecated
   */
  stroke1: '#E5ECF0',
  /**
   * @deprecated
   */
  stroke2: '#C2D0D9',
  /**
   * @deprecated
   */
  stroke3: '#D2DCE8',
  /**
   * @deprecated
   */
  stroke4: '#FFFFFF',
  /**
   * @deprecated
   */
  stroke5: '#ADC1CD',

  /**
   * @deprecated
   */
  text1: '#000000',
  /**
   * @deprecated
   */
  text2: '#FFFFFF',
  /**
   * @deprecated
   */
  text3: '#819AA9',
  /**
   * @deprecated
   */
  text4: '#ADC1CD',
  /**
   * @deprecated
   */
  text5: '#819AA9',

  /**
   * @deprecated
   */
  text6: '#C2D0D9',

  /**
   * @deprecated
   */
  text7: '#A4CDFA',

  /**
   * @deprecated
   */
  text8: '#7BB5F6',
  /**
   * @deprecated
   */
  warning1: '#FFA06A',
};

/**
 * @deprecated
 */
const darkV1: ColorsV1 = {
  ...lightV1,
  background1: '#10191E',

  background2: '#19252D',

  background4: '#3E5867',

  background5: '#19252D',
  background6: '#19252D',

  background7: '#3E5867',
  background12: '#19252D',
  danger1: '#FA5353',
  goal: {
    ...lightV1.goal,

    goal1: '#BB9B80',
    goal2: '#D0A16C',
    goal3: '#D68659',
    goal4: '#C76969',
    goal5: '#60BA9A',
    goal6: '#829998',
    goal7: '#629797',
    goal8: '#91A4B2',
    goal9: '#719BC3',
    goal10: '#499CB1',
    goal11: '#55839B',
  },
  icon1: '#fff',

  icon2: '#000',
  icon8: '#3E5867',
  info1: '#559DEE',
  note: {
    ...lightV1.note,

    note1: '#202326',
    note2: '#162F2C',
    note3: '#1C2837',
    note4: '#322D28',
    note5: '#27253A',
  },
  onboarding1: '#202326',
  primary1: '#559DEE',
  primary3: '#1F4571',

  secondary1: '#25D2A2',
  secondary2: '#33DEAE',
  secondary5: '#10191E',
  secondary6: '#324440',

  secondary7: '#324440',
  stroke1: '#5E7685',
  stroke2: '#5E7685',

  stroke3: '#294251',
  text1: '#fff',
  text2: '#000',

  text4: '#3E5867',

  text6: '#3E5867',

  warning1: '#FF8C00',
};
